<template>
    <v-edit-dialog :return-value.sync="item.no" large cancel-text="취소" save-text="변경" v-on="{ save }">
        <slot />
        <template #input> <v-text-field v-model="item.no" v-bind="attrs_input" type="number" class="mt-3" /> </template>
    </v-edit-dialog>
</template>

<script>
export default {
    props: {
        value: { type: Object, default: () => ({}) },
    },
    data: () => ({
        item: {},
        attrs_input: {
            dense: true,
            outlined: true,
            hideDetails: "auto",
            persistentPlaceholder: true,
        },
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.item = JSON.parse(JSON.stringify(this.value));
        },
        save() {
            let { _id, no } = this.item;
            let form = { _id, no };

            this.$emit("update", form);
        },
    },
};
</script>

<style>
</style>